import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import apiFunctions from "../../../api/functions.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";

import moment from 'moment';
import { format, formatCurrency } from '../../../functions/functions';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            cuenta_id: null,
            movimientos: [],
            postVariables: ['cuenta_id', 'movimientos'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            cuenta_id: null,
            movimientos: [],
            errors: [],
        });
    }

    getData() {
        const { postVariables, fecha } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        this.setState({
            movimientos: data.mov.map((e) => e.id),
        })
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        const { movimientos } = this.state;

        if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Asignar Cuentas",
                buttonTitle: "Asignar Cuentas",
                danger: false,
                buttonIcon: "fa fa-edit fa-lg",
                successMessage: ".",
                saveButton: (movimientos.length==0),
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: null,
            };
        } 
    }

    onValidation(){
        const { cuenta_id } = this.state;
        let error = {};
        let validate = true;

        if (cuenta_id==null){
            error.cuenta_id= [{code: "required", detail: "Selecciones una cuenta"}];
            validate = false;
        }

        this.setState({
            errors: error,
        })
        return validate;
    }

    render() {
        const { cuenta_id, movimientos } = this.state;
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.caja.asignarCuentas : null)}
                submitUrl={(vars.submitType ? api.caja.asignarCuentas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                {(movimientos.length>0) ?
                <section className="ui-modal-section">
                    <p className="ui-section-label">Asignación</p>
                    <div className="ui-form-stack">
                        <p className="ui-inline-message">{'Se le asignará la cuenta a '+movimientos.length+' movimiento'+(movimientos.length==1 ? '' : 's')}</p>
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Cuenta"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={vars.disabled}
                                    url={api.caja.cuentas}
                                    parameters={{
                                        sort:['nombre'],
                                        paginationEnabled:false,
                                    }}
                                    value={cuenta_id}
                                    onChange={(data) => this.onChangeField('cuenta_id', (data ? data.id : null))}
                                />
                            }
                            error={() => this.getError('cuenta_id')}
                        />
                    </div>
                </section>
                :
                <p className="ui-empty-state">No hay movimientos sin cuentas</p>}
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosCaja/ModalCuenta.js